/**
 * Reorder service — read the per-item replenishment thresholds and the alerts
 * they produce.
 *
 * "Reorder config" is the policy (reorderPoint + safetyStock + optional
 * maxStock/leadTime/preferredSupplier per facility#item); "reorder alerts" are
 * what the scheduled reorder-check job raises when on-hand crosses those
 * thresholds (WARNING below reorderPoint, CRITICAL below safetyStock). The
 * Reorder Config page edits the policy; the Reorder Alerts page consumes the
 * alerts.
 */
import { apiRequest } from "./apiClient"
import type { ReorderAlert } from "src/types/reorderAlert"

interface ReorderConfig {
  facilityCode: string
  itemCode: string
  reorderPoint: number
  safetyStock: number
  preferredSupplier: string
  leadTimeDays: number
}

export function listReorderConfigs(facility: string, pageSize = 100, nextToken?: string): Promise<{ data: ReorderConfig[]; nextToken?: string | null }> {
  let url = `/reorder-config?facility=${encodeURIComponent(facility)}&pageSize=${pageSize}`
  if (nextToken) url += `&nextToken=${encodeURIComponent(nextToken)}`
  return apiRequest(url)
}

export function upsertReorderConfig(config: ReorderConfig): Promise<void> {
  return apiRequest("/reorder-config", { method: "POST", body: config })
}

export function listReorderAlerts(facility: string): Promise<{ data: ReorderAlert[] }> {
  return apiRequest(`/reorder-alerts?facility=${encodeURIComponent(facility)}`)
}
